const InitialAdminState = {
    onlineUserCount : 0,
    userCountId:0,
    radioBtnClick : true

};

export default InitialAdminState;


// WEBPACK FOOTER //
// ./src/components/Admin/AdminRoot/InitialAdminState.js